import { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link, useParams, useHistory } from "react-router-dom";
import { scroller } from "react-scroll";
import logoHeader from "../../assets/logo.png";
import { buildUtmQueryString } from "../../config/whatsappConfig";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";

const NAV_ITEMS = [
  { label: "Inicio", sectionId: "inicio", route: "/todos" },
  { label: "Venta Directa", sectionId: "convencional", route: "/convencional" },
  { label: "Financiaciones", sectionId: "financiaciones", route: "/convencional" },
];

const buildRouteWithUtms = (route) => `${route}${buildUtmQueryString()}`;

const Header = () => {
  const { openConsultaForm } = useWhatsAppConsulta();
  const utmSearch = buildUtmQueryString();
  const history = useHistory();
  const { tipo } = useParams();

  useEffect(() => {
    if (tipo !== "todos" && tipo !== "convencional" && tipo !== "plan" && tipo !== undefined) {
      history.push(buildRouteWithUtms("/todos"));
    }
  }, []);

  const handleNavClick = ({ sectionId, route }) => {
    const currentTipo = tipo || "todos";
    const targetTipo = route.replace("/", "") || "todos";

    if (currentTipo !== targetTipo) {
      history.push(buildRouteWithUtms(route));
    }

    setTimeout(
      () => {
        scroller.scrollTo(sectionId, { smooth: true, duration: 500, offset: -10 });
      },
      currentTipo !== targetTipo ? 350 : 0,
    );
  };

  return (
    <Container fluid className="header">
      <Container>
        <Row className="row-header align-items-center">
          <Col md={4} xs={12} className="text-sm-start text-center">
            <Link to={{ pathname: "/todos", search: utmSearch }}>
              <img src={logoHeader} alt="Montironi Hyundai" className="header-logo img-fluid" />
            </Link>
          </Col>
          <Col
            md={8}
            xs={12}
            className="text-sm-end text-center justify-content-md-end justify-content-center d-md-flex d-none align-items-center gap-2 pt-md-0 pt-3"
          >
            {NAV_ITEMS.map((item) => (
              <button
                key={item.sectionId}
                type="button"
                className="link-header px-sm-2"
                onClick={() => handleNavClick(item)}
              >
                {item.label}
              </button>
            ))}
            <Button
              className="btn-hyundai-corporate ms-2"
              onClick={() => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: "solicitud_presupuesto" });
                openConsultaForm();
              }}
            >
              Solicitar cotización
            </Button>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Header;

